import { Component, OnInit } from '@angular/core';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { ConfirmationPopupComponent } from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';
import { CommonService } from 'src/app/share/services/common/common.service';

@Component({
    selector: 'app-supporting-document-type-list',
    templateUrl: './supporting-document-type-list.component.html',
    styleUrl: './supporting-document-type-list.component.scss',
    standalone: false
})
export class SupportingDocumentTypeListComponent implements OnInit {
  public readonly faEdit = faEdit;
  public readonly faTrash = faTrash;
  isEdit: boolean = false;
  selectedSupportingDocumentType: any = null;
  openSupportingDocumentTypePanel: boolean = false;
  page: number = 0;
  totalRecords: number = 0;
  errorMessage: string;
  isErrorToster: boolean = false;
  isSuccessToster: boolean = false;
  tosterMessage: any;
  loadRecords: boolean = false;
  supportingDocumentTypes: any[] = [];

  constructor(
    private readonly lookupService: LookupService,
    private readonly modal: NgbModal,
    private readonly commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.getSupportingDocumentTypeList(this.page);
  }

  isEditSupportingDocumentType(item: any) {
    document.body.style.overflow = 'hidden';
    this.selectedSupportingDocumentType = item;
    this.openSupportingDocumentTypePanel = true;
    this.isEdit = true;
  }

  closeSupportingDocumentTypePanel() {
    document.body.style.overflow = '';
    this.openSupportingDocumentTypePanel = false;
    this.selectedSupportingDocumentType = null;
    this.isEdit = false;
  }

  onPageChange(event: any): void {
    this.page = event.page;
    this.getSupportingDocumentTypeList(this.page);
  }

  getSupportingDocumentTypeList(page: any) {
    this.loadRecords = true;
    const params: any = {
      page: page,
    }
    this.lookupService.getSupportingDocumentTypeList(params)?.subscribe({
      next: (res) => {
        this.loadRecords = false;
        this.supportingDocumentTypes = res?.data || [];
        this.totalRecords = res?.resultSize;
      },
      error: (error) => {
        this.errorMessageFunction(error?.error?.message);
      }
    })
  }

  deleteSupportingDocumentType(supportingDocumentType: any) {
    let dialogRef = this.modal.open(ConfirmationPopupComponent, { keyboard: false, backdrop: "static" });

    if (dialogRef?.componentInstance) {
      dialogRef.componentInstance.header = 'Delete Confirm';
      dialogRef.componentInstance.message = `Are you sure you want to delete ${supportingDocumentType.name}`;
      dialogRef.componentInstance.lableName = 'Delete';
      dialogRef.result.then(
        (result) => {
          if (result) {
            this.lookupService.deleteSupportingDocumentType(supportingDocumentType?._id).subscribe({
              next: () => {
                this.page = this.supportingDocumentTypes.length === 1 ? this.page - 1 : this.page;
                this.isSuccessToster = true;
                this.tosterMessage = "Supporting document type is deleted successfully";
                this.getSupportingDocumentTypeList(this.page);
              },
              error: (error) => {
                this.errorMessageFunction(error?.error?.message);
              }
            });
          }
        },
      );
    }
  }

  errorMessageFunction(message: any) {
    this.loadRecords = false;
    this.errorMessage = message;
    this.isErrorToster = true;
    this.tosterMessage = message;
  }

  successMessageFunction(message: any) {
    this.isSuccessToster = true;
    this.tosterMessage = message;
    this.getSupportingDocumentTypeList(0);
  }

  successTosterFromAddSupportingDocumentTypeComponent(message: any) {
    this.successMessageFunction(message);
  }

  closingToster(value: any) {
    this.isErrorToster = value;
    this.isSuccessToster = value;
    this.tosterMessage = "";
  }

  hasEditAccess(): boolean {
    return this.commonService.hasAllowedAction();
  }

}
